import { forwardRef } from 'react';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { SettingsIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ComposerSettingsButton = /*#__PURE__*/forwardRef(({
  menuOpen,
  onClick
}, settingsButtonRef) => {
  return /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "ai-settings-button",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.settings.tooltip"
    }),
    buttonRef: settingsButtonRef,
    tooltipProps: Object.assign({}, menuOpen && {
      open: false
    }, {
      placement: 'top'
    }),
    use: "transparent",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(SettingsIcon, {})
  });
});
ComposerSettingsButton.displayName = 'SettingsButton';